import * as actions from '../actions';
export const initialState = {
  parameters: undefined
}

export function parameterReducer(state = initialState, action: actions.Actions) {
  switch (action.type) {
  case actions.GET_PARAMETERS_SUCCESS:
      return {
        ...state,
        parameters: action.payload.updateParameterModel.parameters
      };
  default:
    return state;
  }
}



// WEBPACK FOOTER //
// ./src/app/businessRule/store/reducers/parameter.reducer.ts